import { zustandStorage } from "@helpers/storage";
/* -----------------Globals--------------- */
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

/* -----------------Types--------------- */
type State = {
	hasShownQuizAlert?: boolean;
	hasShownPracticeTestAlert?: boolean;
	hasShownConfidenceOnboardingDialog?: boolean;
	hasCompletedProethicaOnboarding?: boolean;
	hasShownMasteryTopicsAlert?: boolean;
	lastLoggedInEmail?: string;
	showAvatarUpdatedMessage?: boolean;
	language?: string;
	showAudioPlaybackTestDialog: boolean;
	setLastLoggedInEmail: (email: string) => void;
	setHasShownMasteryTopicsAlert: (hasShown: boolean) => void;
	setHasShownQuizAlert: (hasShown: boolean) => void;
	setHasShownPracticeTestAlert: (hasShown: boolean) => void;
	setHasShownConfidenceOnboardingDialog: (hasShown: boolean) => void;
	setHasCompletedProethicaOnboarding: (hasCompleted: boolean) => void;
	setShowAvatarUpdatedMessage: (hasShown: boolean) => void;
	setLanguage: (lang: string) => void;
	toggleAudioPlaybackTestDialog: () => void;
};

/* -----------------Store--------------- */
export const useGlobalStore = create<State>()(
	persist(
		(set) => ({
			showAudioPlaybackTestDialog: true,
			setHasShownMasteryTopicsAlert: (hasShown) =>
				set({ hasShownMasteryTopicsAlert: hasShown }),
			setHasShownQuizAlert: (hasShown) => set({ hasShownQuizAlert: hasShown }),
			setHasShownConfidenceOnboardingDialog: (hasShown) =>
				set({ hasShownConfidenceOnboardingDialog: hasShown }),
			setHasCompletedProethicaOnboarding: (hasCompleted) =>
				set({ hasCompletedProethicaOnboarding: hasCompleted }),
			setHasShownPracticeTestAlert: (hasShown) =>
				set({ hasShownPracticeTestAlert: hasShown }),
			setLastLoggedInEmail: (email) => set({ lastLoggedInEmail: email }),
			setShowAvatarUpdatedMessage: (hasShown) =>
				set({ showAvatarUpdatedMessage: hasShown }),
			setLanguage: (lang) => set({ language: lang }),
			toggleAudioPlaybackTestDialog: () =>
				set((state) => ({
					showAudioPlaybackTestDialog: !state.showAudioPlaybackTestDialog,
				})),
		}),

		{
			name: "global-store",
			storage: createJSONStorage(() => zustandStorage),
		},
	),
);
